export default {
  tag: "What We Do",
  title1: "Stay Compliant!",
  title2: "Your Permit Runner",
  subtitle:
    "From Consulting to planning your kitchen, we are here to help you as the food truck operator keep focus on your business.",
  learnMore: "Learn more",
  items: [
    {
      title: "Permit Assistance",
      description:
        "We handle all Orange County permit applications, renewals, and compliance tracking so you never miss a deadline.",
    },
    {
      title: "Regulatory Compliance",
      description:
        "Stay up-to-date with OC health codes, fire safety regulations, and zoning laws with our compliance monitoring service.",
    },
    {
      title: "MFF Standard Operation",
      description:
        "Connect with certified commissary kitchens and food truck builders who specialize in Orange County-approved outfitting.",
    },
  ],
};